import { createSlice } from '@reduxjs/toolkit'
import { TPlayer } from 'pages/PlayersPage/types'

export const playersSlice = createSlice({
  name: 'players',
  initialState: {
    players: [],
    selectedPlayers: [],
    editablePlayer: {
      name: null,
      birthDate	: null,
      country: null,
      city: null,
      plays: null,
      weight: null,
      height: null,
      avatar: null,
      gender: 'man',
      initialRating: 100,
    },
    count: 0
  },
  reducers: {
    setPlayers: (state, action) =>
      ({
        ...state,
        players: action.payload
      }),
    setChankPlayers: (state: any, action: {payload: TPlayer[]}) => {
      return {
        ...state,
        players: [...state.players, ...action.payload]
      }
    },
    setCountPlayers: (state: any, action: {payload: number}) => {
      return {
        ...state,
        count: action.payload
      }
    },
    setSelectedPlayers: (state, action) => ({
      ...state,
      selectedPlayers: action.payload
    }),
    setEditablePlayer: (state, {payload: editablePlayer}) => {
      return {
        ...state,
        editablePlayer: {
          ...state.editablePlayer,
          ...editablePlayer
        }
      }
    },
    clearEditablePlayer: (state) =>
    ({
      ...state,
      editablePlayer: {
        name: null,
        birthDate	: null,
        country: null,
        city: null,
        plays: null,
        weight: null,
        height: null,
        avatar: null,
        gender: 'man',
        initialRating: 100,
      }
    })
  }
})

export const {
  setPlayers,
  setChankPlayers,
  setCountPlayers,
  setSelectedPlayers,
  setEditablePlayer,
  clearEditablePlayer
} = playersSlice.actions
export default playersSlice.reducer
